import { render } from "./tests-index.vue?vue&type=template&id=f61b3d68"
import script from "./tests-index.vue?vue&type=script&lang=js"
export * from "./tests-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__